import React, { useEffect, useMemo, useState } from 'react';
import { OnChange } from 'react-final-form-listeners';
import { useFormState, useForm } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';

import QCXAutocompleteSelect from '../../autocomplete-select/QCXAutocompleteSelect'; // lista suspensa
import QCXFinalTextField from '../../final-text-field/QCXFinalTextField'; // texto
import QCXFinalCheckboxField from '../../final-checkbox-field/QCXFinalCheckboxField'; // boolean
import QCXFinalNumericDecimalField from '../../final-numeric-decimal-field/QCXFinalNumericDecimalField'; // float
import QCXFinalNumericIntegerField from '../../final-numeric-integer-field/QCXFinalNumericIntegerField'; // inteiros

export default function ValorReal({ metadado, isConsult, codAtributoPai, basePath = '', ...restProps }) {
  const [label, setLabel] = useState('');
  const [name, setName] = useState('');
  const [codigo, setCodigo] = useState('');

  useEffect(() => {
    if (!metadado) return null;

    setCodigo(metadado.codigo || '');
    setLabel(`${metadado.descricaoCodigo} (${metadado.codigo})` || '');
    setName(`${basePath}.${metadado.codigo}.valor` || '');

    return null;
  }, []);

  if (!name) {
    return null;
  }

  return (
    <>
      <QCXFinalNumericDecimalField
        id={codigo}
        key={codigo}
        name={name}
        label={label}
        disabled={isConsult}
        scale={5}
        allowNegative={false}
        {...restProps}
      />
    </>
  );
}
